// +----------------------------------------------------------------------
// | CRMEB [ CRMEB 赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB 并不是自由软件，未经许可不能去掉 CRMEB 相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var dealerErrorLogRouter = {
  path: '/dealerErrorLog',
  component: Layout,
  redirect: '/dealerErrorLog/list',
  name: 'DealerErrorLog',
  meta: {
    title: '经销商错误日志',
    icon: 'el-icon-warning-outline',
    noCache: true,
    alwaysShow: true
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/dealerErrorLog/index');
    },
    name: 'DealerErrorLogList',
    meta: {
      title: '经销商错误日志',
      noCache: true,
      affix: false,
      icon: 'el-icon-warning-outline',
      perms: 'api:admin:kingdee:dealer:error:list'
    }
  }],
  // 确保这是一个顶级菜单，不属于任何其他菜单
  pid: 0
};
export default dealerErrorLogRouter;